import React,{useEffect,useState} from 'react'
import { StateUseContext } from '../../context/UserDetailContext';
import {upadateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

import moment from 'moment';

const ProfileInfoForm = ({nexTabChange}) => {

    const {userDetail,countryCode,setUserDetail} = StateUseContext();
    const {name,email,dob,mobile_no,gender,tshirt_size,target_exam,is_paid,paid_status,country_id,country_code} = userDetail !==undefined && userDetail
    
    const [studentName,setStudentName] = useState({value:'',error:''});
    const [UserEmail,setUserEmail] = useState({value:'',error:''});
    const [userDob,setUserDob] = useState({value:'',error:''});
    const [mobileNumber,setMobileNumber] = useState({value:'',error:''});
    const [UserGender,setUserGender] = useState({value:'',error:''});
    const [loading,setLoading] = useState(false);

    const [userCountryCode,setUserCountryCode] = useState({value:'',error:''});

    // Handle manual country code entry for Non-GCC (id: 14)
    const handleManualCountryCode = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 3) {
            value = value.slice(0, 3);
        }
        const normalized = value ? `+${value}` : '';
        setUserCountryCode({ ...userCountryCode, value: normalized, error: '' });
    };

    const currentDate = moment().format('YYYY-MM-DD');
    const minDate = moment(currentDate).subtract(4, 'years').format('YYYY-MM-DD');

    useEffect(() => {
        if(userDetail !==undefined){
            setStudentName((prev) => ({...prev,value:name}))
            setUserEmail((prev) => ({...prev,value:email}))
            setUserDob((prev) => ({...prev,value:dob}))
            setMobileNumber((prev) => ({...prev,value:mobile_no}))
            setUserGender((prev) => ({...prev,value:gender}))
            setUserCountryCode((prev) => ({...prev,value:country_code}))
            // setTshirtSize((prev) => ({...prev,value:tshirt_size}))
            // setTargetExam((prev) => ({...prev,value:target_exam}))
        }

        
    },[userDetail,name,email,dob,mobile_no,gender,country_code,tshirt_size,target_exam])

    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true

        if (!studentName.value) {
            formIsValid = false
            let msg = "Please enter student name"
            setStudentName({ ...studentName, error: msg })
        }
        else if (studentName.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setStudentName({ ...studentName, error: msg })
        }
        else if (studentName.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setStudentName({ ...studentName, error: msg })
        }
        else if (!nameRegex.test(studentName.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setStudentName({ ...studentName, error: msg })
        }

        // Phone number
        if (!mobileNumber.value) {
            formIsValid = false
            let msg = "Please enter your mobile number"
            setMobileNumber({ ...mobileNumber, error: msg })
        }

        if (!mobileRegex.test(mobileNumber.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setMobileNumber({ ...mobileNumber, error: msg })
        }

        if(country_id === 14){
            // Non-GCC: mobile length 6 to 12
            if(mobileNumber.value.length < 6){
                formIsValid = false
                let msg = "Min 6 Digit Length"
                setMobileNumber({ ...mobileNumber, error: msg })
            }
            else if(mobileNumber.value.length > 12){
                formIsValid = false
                let msg = "Max 12 Digit Length"
                setMobileNumber({ ...mobileNumber, error: msg })
            }

            // Country code validation for manual input (digits only, length 2-3)
            const manualCodeDigits = (userCountryCode.value || '').replace('+','');
            if(!manualCodeDigits || manualCodeDigits.length < 2 || manualCodeDigits.length > 3){
                formIsValid = false
                let msg = "Country code must be 2-3 digits"
                setUserCountryCode({ ...userCountryCode, error: msg })
            }
        }
        else if(userCountryCode?.value !=='+91'){
            if(country_id ===1 || country_id ===2 || country_id ===4 || country_id ===5){
                if(mobileNumber.value.length < 8){
                    formIsValid = false
                    let msg = "Min 8 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 8){
                    formIsValid = false
                    let msg = "Max 8 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
            }
            else if(country_id ===6){
                if(mobileNumber.value.length < 9){
                    formIsValid = false
                    let msg = "Min 9 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 9){
                    formIsValid = false
                    let msg = "Max 9 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
            }
    
            else if(country_id ===7){
                if(mobileNumber.value.length < 9){
                    formIsValid = false
                    let msg = "Min 9 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 10){
                    formIsValid = false
                    let msg = "Max 10 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
            }
        }
        

        if (!userDob.value) {
            formIsValid = false
            let msg = "Please select date of birth"
            setUserDob({ ...userDob, error: msg })
        }

        if (!UserGender.value) {
            formIsValid = false
            let msg = "Please select your gender"
            setUserGender({ ...UserGender, error: msg })
        }

        if(formIsValid){
            setStudentName({...studentName,error:''})
            setUserDob({...userDob,error:''})
            setMobileNumber({...mobileNumber,error:''})
            setUserGender({...UserGender,error:''})
            // setTshirtSize({...tShirtSize,error:''})
            // setTargetExam({...targetExam,error:''})
        }

        return formIsValid;
    }


    const submitFormHandler = async(e) => {
    e.preventDefault();
    if(validation()){
        setLoading(true)
        const data = {
            id:userDetail?.id,
            name:studentName.value,
            email:UserEmail.value,
            dob:userDob.value,
            mobile_no:mobileNumber.value,
            gender:UserGender.value,
            country_code:userCountryCode.value,
            // tshirt_size:tShirtSize.value?.name ||'',
            // target_exam:targetExam.value?.id ||''
        }
        
    
        try {
            await upadateProfileDetail(data).then((res) => {
                if(res.status){
                    setLoading(false)
                    setUserDetail({...userDetail,...res?.data})
                    swal(res?.message,'','success').then(() => {
                        nexTabChange()
                    })
                }
                else{
                    setLoading(false)
                    swal(res?.message,'','error')
                }
            })
        } catch (error) {
            console.log('update profile..',error)
        }
    }
 
    }


  return (

        userDetail ? 
        <form onSubmit={submitFormHandler} className="row mt-3 gx-lg-5">
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Student Full Name<span>*</span></label>
                    <input type="text" disabled={is_paid ===1 || paid_status===1} value={studentName.value}
                     onChange={(e) =>{
                        let value = e.target.value
                        value = value.replace(/[^A-Za-z ]/ig, '')   
                        setStudentName({...studentName,value:value,error:''})
                    }
                    } 
                     className="form-control"  
                     placeholder="Student Name"
                     />
                    {studentName?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{studentName.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Student Email<span>*</span></label>
                    {email ? <input type='email' className="form-control" disabled readOnly value={email}/> 
                    : <input type="email" value={UserEmail.value} disabled readOnly onChange={e => setUserEmail({...UserEmail,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>

                    }

                </div>
            
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Date of Birth<span>*</span></label>
                    <input type="date" max={minDate} value={userDob.value} onChange={e => setUserDob({...userDob,value:e.target.value,error:''})} className="form-control" />
                    {userDob?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{userDob.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            {/* <label className="form-label d-none d-lg-block">&nbsp;</label> */}
                            {country_id === 14 ? (
                                <div className="d-flex align-items-center custom_country_code_input">
                                    <span className="me-1 fw-semibold">+</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Code"
                                        value={userCountryCode.value?.replace('+', '') || ''}
                                        onChange={handleManualCountryCode}
                                        disabled={is_paid ===1 || paid_status===1}
                                    />
                                </div>
                            ) : (
                                <select  className='form-control' value={userCountryCode.value} onChange={(e) => setUserCountryCode({...userCountryCode,value:e.target.value,error:''})}  disabled={is_paid ===1 || paid_status===1}>
                                    {countryCode?.map((item => (
                                            <option value={item.isd_code} defaultValue={item.isd_code === country_code} key={item.id}>{item.isd_code}</option>
                                    )))}
                                </select>
                            )}
                            {userCountryCode?.error?.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{userCountryCode.error}</small>}
                        </div>
                        <div className="col-10">
                            <input type="text" disabled={is_paid ===1 || paid_status===1} value={mobileNumber.value} onChange={e => setMobileNumber({...mobileNumber,value:e.target.value,error:''})} className="form-control" placeholder="Enter mobile number"/>
                        </div>
                    </div>
                    {mobileNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{mobileNumber.error}</small>}

                </div>

            <div className="col-md-6 mb-3">
                    <label className="form-label">Gender<span>*</span></label>
                    <select className="form-control" value={UserGender.value?.toLowerCase() ||''} onChange={e => setUserGender({...UserGender,value:e.target.value,error:''})}>
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="others">Others</option>
                    </select>
                    {UserGender?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{UserGender.error}</small>}

                </div>

                <div className="col-md-12 mt-2">
                    {loading ? <button className="btn btn-default" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                Updating...</button>:<button type="submit" className="btn btn-default">Save & Next</button>}
                    
                    {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
                </div>


        </form>
        : 'loading'
  )
}

export default ProfileInfoForm